import React, { useEffect, useState } from "react";
import { FiLogIn, FiSearch, FiShoppingBag } from "react-icons/fi";
import Logo from "../../assets/images/yourstylist/yourstyle (4).jpg";
import LogoMobile from "../../assets/images/yourstylist/logo";
import DrawerNavigation from "./Drawer";
import { Link } from "react-router-dom";

const NavBar = () => {
  const categories = [
    {
      name: "Dresses",
      subcategories: [
        {
          name: "Special Offer",
          link: "https://yourstylistclothing.com/",
        },
        {
          name: "Casual Dresses",
          link: "https://yourstylistclothing.com/",
        },
        {
          name: "",
          link: "",
        },
        {
          name: "Formal Dresses",
          link: "https://yourstylistclothing.com/",
        },
        {
          name: "",
          link: "",
        },
        {
          name: "Summer Dresses",
          link: "https://yourstylistclothing.com/",
        },
      ],
    },
    {
      name: "Tops",
      subcategories: [
        {
          name: "Special Offer",
          link: "https://yourstylistclothing.com/",
        },
        {
          name: "Blouses",
          link: "https://yourstylistclothing.com/",
        },
        {
          name: "",
          link: "",
        },
        {
          name: "Cardigans",
          link: "https://yourstylistclothing.com/",
        },
      ],
    },
    {
      name: "Skirts",
      subcategories: [
        {
          name: "Special Offer",
          link: "https://yourstylistclothing.com/",
        },
        {
          name: "Maxi Skirts",
          link: "https://yourstylistclothing.com/",
        },
        {
          name: "",
          link: "",
        },
        {
          name: "Mini Skirts",
          link: "https://yourstylistclothing.com/",
        },
        {
          name: "",
          link: "",
        },
        {
          name: "Fairy Long Skirts",
          link: "https://yourstylistclothing.com/",
        },
        {
          name: "",
          link: "",
        },
        {
          name: "Short Skirts",
          link: "https://yourstylistclothing.com/",
        },
      ],
    },
    {
      name: "One-Sets",
      subcategories: [
        {
          name: "Special Offer",
          link: "https://yourstylistclothing.com/",
        },
        {
          name: "Avery Sets",
          link: "https://yourstylistclothing.com/",
        },
        {
          name: "",
          link: "",
        },
        {
          name: "Innlay Sets",
          link: "https://yourstylistclothing.com/",
        },
        {
          name: "",
          link: "",
        },
        {
          name: "Innlay Sets",
          link: "https://yourstylistclothing.com/",
        },
        {
          name: "",
          link: "",
        },
        {
          name: "Cherry Sets",
          link: "https://yourstylistclothing.com/",
        },
      ],
    },
    {
      name: "T-Shirts",
      subcategories: [
        {
          name: "Special Offer",
          link: "https://yourstylistclothing.com/",
        },
        {
          name: "Oversized Simple Tees",
          link: "https://yourstylistclothing.com/",
        },
        {
          name: "",
          link: "",
        },
        {
          name: "Oversized Graphic Tees",
          link: "https://yourstylistclothing.com/",
        },
        {
          name: "",
          link: "",
        },
        {
          name: "Regular Fit Tees",
          link: "https://yourstylistclothing.com/",
        },
      ],
    },
  ];

  const [scrolling, setScrolling] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 0) {
      setScrolling(true);
    } else {
      setScrolling(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div className="w-screen h-full z-10">
      <div
        className={` hidden md:block py-3 w-screen fixed z-20 top-0 px-5    bg-white shadow-md text-black`}
      >
        <div className="flex justify-between items-center">
          <div className="w-[200px]"></div>
          <Link to={"/"}>
            <img
              src={LogoMobile}
              alt=""
              className="w-[180px] h-[50px]  rounded"
            />
            {/* <img src={Logo} alt="" className="w-[110px] h-[110px] " /> */}
          </Link>
          <div className="flex gap-3 w-[200px]">
            <a href="https://yourstylistclothing.com/login">
              <div className="gap-2 flex items-center">
                <FiLogIn />
                Login
              </div>
            </a>

            <a href=" https://yourstylistclothing.com/">
              <div className="gap-2 flex items-center">
                <FiShoppingBag />
                Cart
              </div>
            </a>
          </div>
        </div>
        <div className="flex items-center mt-5 justify-center">
          {/* <div className="md:w-[170px] lg:w-[220px] "></div> */}
          <div className="flex-grow   flex flex-wrap gap-4 items-center justify-center">
            {categories.map((category) => {
              return (
                <div key={category.name} className="dropdown dropdown-hover">
                  <div
                    tabIndex={0}
                    role="button"
                    className=" text-gray-500 text-sm m-1"
                  >
                    {category.name}
                  </div>
                  {category.subcategories && (
                    <ul
                      tabIndex={0}
                      className="dropdown-content  grid grid-cols-2 text-gray-500 z-[1] menu py-3 px-4 shadow bg-base-100 rounded w-max"
                    >
                      {category.subcategories.map((subCategory, subIndex) => (
                        <li key={subIndex}>
                          {subCategory.name === "" ? (
                            <span className="opacity-0"></span>
                          ) : (
                            <a href={subCategory.link}>{subCategory.name}</a>
                          )}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              );
              // return <p key={category}>{category}</p>;
            })}
          </div>
          {/* <div className="flex border-b  md:w-[170px] lg:w-[220px] h-full border-black items-center">
            <FiSearch />
            <input
              type="text"
              placeholder="Search Products"
              className="w-full lg:w-[200px] bg-transparent border-0 focus:border-0 pl-2"
            />
          </div> */}
        </div>
      </div>
      <div className="flex items-center justify-between md:hidden bg-white">
        <DrawerNavigation />
        <Link to={"/"}>
          <img src={LogoMobile} alt="" className="w-[110px] h-[30px] " />
        </Link>
        <div className="w-[20px] p-4 "></div>
      </div>
    </div>
  );
};

export default NavBar;
